import { combineEpics } from 'redux-observable'
import { concatAll, ignoreElements, switchMap, tap } from 'rxjs/operators'

import { HttpError } from 'modules/http-client'
import { Epic } from 'modules/store'

import { RouterActions } from '../../store'

import { links } from '../../app.links'
import { Providers } from '../auth.module'

import * as fromCore from '../../core/store'
import { BonusPeriodInfoDto } from '../../shared'
import * as fromShared from '../../shared/store'
import * as fromAuth from './auth.actions'

type AuthActions = fromAuth.AuthActions | RouterActions

const getActiveBonusPeriod = (periods: BonusPeriodInfoDto[]): BonusPeriodInfoDto =>
  periods.find((period) => period.isActive && period.isDefault) || periods[0] // When no active and default period was found, the first will be active

export const currentUserEpic: Epic<any, any, Providers> = (actions$, _, { authService }) =>
  actions$.ofType<fromAuth.CurentUserAction>(fromAuth.GET_CURRENT_USER).pipe(
    switchMap(() =>
      authService
        .currentUser()
        .then((user) => [
          new fromAuth.CurentUserSuccessAction(user),
          new fromShared.sharedActions.SetActiveBonusPeriodAction(
            getActiveBonusPeriod(user.bonusPeriods),
            user.bonusPeriods
          ),
        ])
        .catch((reason: HttpError) => [new fromAuth.CurentUserFailureAction(reason)])
    ),
    concatAll()
  )

export const redirectLoggedInUserEpic: Epic<any, any, Providers> = (actions$, _, { authService }) =>
  actions$.ofType(fromAuth.GET_CURRENT_USER_SUCESS).pipe(
    tap(() => {
      authService.hasRedirectOrigin() && authService.clearRedirectOrigin()
    }),
    ignoreElements()
  )

export const notLoggedInEpic: Epic<AuthActions, any, Providers> = (actions$, _, { authService }) =>
  actions$.ofType(fromAuth.GET_CURRENT_USER_ERROR).pipe(tap(() => authService.setRedirectOrigin()), ignoreElements())

export const logoutEpic: Epic<AuthActions, any, Providers> = (actions$, _, { authService }) =>
  actions$.ofType<fromAuth.LogoutAction>(fromAuth.LOGOUT).pipe(
    switchMap(() =>
      authService
        .logout()
        .then(() => {
          return new fromAuth.LogoutSuccessAction()
        })
        .catch(() => {
          return new fromAuth.LogoutFailedAction()
        })
    )
  )

export const loginAsEpic: Epic<AuthActions, any, Providers> = (actions$, _, { authService }) =>
  actions$.ofType<fromAuth.LoginAsAction>(fromAuth.LOGIN_AS).pipe(
    switchMap((action) =>
      authService
        .loginAs(action.payload)
        .then(() => {
          // this is not good - but we need reload whole window because of getting new auth cookie - switched by calling
          // login as API endpoint that causes "identity change"
          window.location.reload()

          return new fromCore.actions.RedirectAction({
            pathname: links.frontFace.personal.goals.myGoals(),
          })
        })
        .catch((reason: HttpError) => new fromAuth.CurentUserFailureAction(reason))
    )
  )

export default combineEpics(currentUserEpic, logoutEpic, notLoggedInEpic, redirectLoggedInUserEpic, loginAsEpic)



// WEBPACK FOOTER //
// ./src/app/auth/store/auth.epic.ts